/* Copyright Verge Technologies 2018
 * @file laboratoryServices.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

// Modules
import React, { Component } from 'react';

// Components
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/footer';
import RequestServiceModal from '../../components/RequestServiceModal/requestServiceModal';
import ThankYouModal from '../../components/ThankYouModal/thankyou.modal';

//import React from 'react';
import { Link } from 'react-router-dom';
import { Query } from 'react-apollo';
import { PulseLoader } from 'react-spinners';
// GraphQL
import { CONTENT_QUERY } from '../../graphql';

// Components
// import Header from '../../components/Header/header';
// import Footer from '../../components/Footer/footer';

//import { Parser } from 'html-to-react';


class LaboratoryServices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestModalOpen: false,
      thankYouModalOpen: false,
      heading: 'Service Request',
    };
  }

  componentDidMount(){
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Header crumbs={this.props.crumbs} />
        <RequestServiceModal
          isOpen={this.state.requestModalOpen}
          closeModal={() => this.setState({ ...this.state, requestModalOpen: false, heading: 'Service Request' })}
          openThankYouModal={() => this.setState({ ...this.state, requestModalOpen: false, thankYouModalOpen: true })}
          heading={this.state.heading}
        />
        <ThankYouModal
          isOpen={this.state.thankYouModalOpen}
          closeModal={() => {
            this.setState({ ...this.state, thankYouModalOpen: false });
          }}
        />
        <div className="page-heading heading-support">Services</div>

      <Query query={CONTENT_QUERY} fetchPolicy="cache-and-network" variables={{ slug: "services" }}>
        {({ loading, error, data }) => {
          if (loading) {
            return (

<div>
        <div className="content-list-container icon-list">
          <ul>
            <li className="services-card" style={{ height: 'auto' }}>
              <div className="icon-block">
                <div className="icon">
                  <svg
                    width="49px"
                    height="60px"
                    viewBox="0 0 49 60"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <g transform="translate(1.000000, 0.000000)" stroke="#004DA9" strokeWidth="3">
                        <polyline points="6.806 12.754 11.506 17.454 20.038 8.982" />
                        <polyline points="6.806 24.502 11.506 29.263 20.038 20.73" />
                        <path d="M7.386,32.23 L15.486,40.392" />
                        <path d="M7.386,40.392 L15.486,32.23" />
                        <path d="M27.888,11.657 L38.835,11.657" />
                        <path d="M27.888,23.657 L38.835,23.657" />
                        <path d="M27.888,35.657 L38.835,35.657" />
                        <polygon points="0.499 1.5 0.499 48.43 30.054 48.43 39.267 57.7 39.267 48.43 45.821 48.43 45.821 1.5" />
                      </g>
                    </g>
                  </svg>
                </div>
                <h5>Application</h5>
              </div>
              <div className="content-block">
                <h2>Application Support</h2>
                <p>
                  In today’s dynamic research environments, receiving complete solutions support for a 
                  purchased instrument or platform has become an integral standard for obtaining the 
                  most robust <u>research</u> outputs. For this reason, we at Separations have a dedicated 
                  Applications Support Division specifically positioned to help our customers make 
                  the most of their research <u>or routine analyses</u>.
                </p>
                <p>With specialised services in techniques scripting, assay development, experimental optimisation, 
                  uniquely tailored training sessions, method troubleshooting and general scientific queries, your 
                  every analytical obstacle is catered for by our highly specialised Applications Support team, 
                  who will work alongside you to provide the necessary assistance so that you can soar to the peaks 
                  of <u>your field of application.</u>  Together, we can achieve <u>Simply</u> Spectacular results.
                </p>
              </div>
              <div className="control">
                <a
                  onClick={() => {
                    this.setState({ requestModalOpen: true, heading: 'Assesment Request' });
                  }}
                  className="button button-green"
                >
                  Request an Assesment
                </a>
              </div>
            </li>
            <li className="services-card" style={{ height: 'auto' }}>
              <div className="icon-block">
                <div className="icon">
                  <svg
                    width="45px"
                    height="56px"
                    viewBox="0 0 45 56"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <g transform="translate(1.000000, 0.000000)" stroke="#004DA9" strokeWidth="3">
                        <rect
                          id="Rectangle_1187"
                          x="0.5"
                          y="22.883"
                          width="10.016"
                          height="14.44"
                        />
                        <path d="M5.478,1.657 L5.478,17.5" id="Line_35" />
                        <path d="M5.478,42.657 L5.478,54.5" id="Line_36" />
                        <rect
                          id="Rectangle_1188"
                          x="16.046"
                          y="28.475"
                          width="10.016"
                          height="14.44"
                        />
                        <path d="M21.023,1.657 L21.023,22.5" id="Line_37" />
                        <path d="M21.023,47.657 L21.023,54.5" id="Line_38" />
                        <rect
                          id="Rectangle_1189"
                          x="31.592"
                          y="17.353"
                          width="10.016"
                          height="14.44"
                        />
                        <path d="M36.63,1.5 L36.63,11.5" id="Line_39" />
                        <path d="M36.63,36.657 L36.63,54.5" id="Line_40" />
                      </g>
                    </g>
                  </svg>
                </div>
                <h5>Calibrations</h5>
              </div>
              <div className="content-block">
                <h2>Calibrations and Service</h2>
                <p>
                  To assure accuracy in every instrument supplied by Separations, 
                  continually use our calibration and validation services to 
                  minimise safety risks and increase accuracy. 
                </p>
              </div>
              <div className="control">
*
              </div>
            </li>
            <li className="services-card" style={{ height: 'auto' }}>
              <div className="icon-block">
                <div className="icon">
                  <svg
                    width="61px"
                    height="61px"
                    viewBox="0 0 61 61"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <g stroke="#004DA9" strokeWidth="3">
                        <path
                          d="M27.319,27.658 L34.744,20.233 C33.0020033,15.6254447 34.0881702,10.4258841 37.529,6.901 C41.0467351,3.38266329 46.3175354,2.28850864 50.945,4.116 L43.351,11.71 C41.3288656,13.7392408 41.3288656,17.0217592 43.351,19.051 C45.3802408,21.0731344 48.6627592,21.0731344 50.692,19.051 L58.117,11.626 C59.7133122,16.1648136 58.5651792,21.21691 55.164,24.62 C51.679806,28.1364873 46.4322925,29.2322777 41.832,27.404 L34.407,34.829 L34.576,34.66 L27.151,42.085 C28.8929967,46.6925553 27.8068298,51.8921159 24.366,55.417 C20.8481713,58.9352289 15.5772463,60.0290165 10.95,58.201 L18.544,50.607 C20.5661344,48.5777592 20.5661344,45.2952408 18.544,43.266 C16.5147592,41.2438656 13.2322408,41.2438656 11.203,43.266 L3.778,50.691 C2.18168775,46.1521864 3.32982079,41.10009 6.731,37.697 C10.214969,34.1801645 15.4625115,33.0839744 20.063,34.912 L27.488,27.487 L27.319,27.658 Z"
                          id="Path_57"
                        />
                        <path
                          d="M43.689,36.096 L57.021,49.428 C59.0431344,51.4572408 59.0431344,54.7397592 57.021,56.769 C54.9917592,58.7911344 51.7092408,58.7911344 49.68,56.769 L36.348,43.437"
                          id="Path_58"
                        />
                        <polyline
                          id="Path_59"
                          points="23.859 19.557 17.193 12.891 12.893 5.803 5.805 1.503 1.505 5.722 5.805 12.894 12.893 17.194 19.559 23.86"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <h5>Repairs</h5>
              </div>
              <div className="content-block">
                <h2>Repairs</h2>
                <p>
                  With the Separations Service Department, you can depend on the highest level of 
                  efficiency and expertise that comes with experience.  Providing you with fast, 
                  on demand repairs, <u>maximising</u> your uptime and optimising performance.
                </p>
              </div>
              <div className="control">
                <a
                  onClick={() => {
                    this.setState({ requestModalOpen: true, heading: 'Repair Request' });
                  }}
                  className="button button-green"
                >
                  Request a Repair
                </a>
              </div>
            </li>
            <li className="services-card" style={{ height: 'auto' }}>
              <div className="icon-block">
                <div className="icon">
                  <svg
                    width="82px"
                    height="61px"
                    viewBox="0 0 82 61"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <g transform="translate(1.000000, 0.000000)" stroke="#004DA9" strokeWidth="3">
                        <path
                          d="M31.343,36.044 C31.215,37.835 31.279,39.498 31.215,41.098 C31.151,45.832 31.151,50.566 31.087,55.298 C31.0394885,57.3269707 29.4059707,58.9604885 27.377,59.008 C23.859,59.008 20.277,59.072 16.758,59.008 C15.2668994,58.9518638 13.8905984,58.1924869 13.048,56.961 C12.8368636,56.6399431 12.7461755,56.2545183 12.792,55.873 C12.728,54.273 12.6,52.61 12.536,51.011 C12.0491022,51.3976872 11.3598978,51.3976872 10.873,51.011 C7.802,47.94 4.796,44.87 1.725,41.799 C0.942061185,41.0199507 0.501882298,39.9609958 0.501882298,38.8565 C0.501882298,37.7520042 0.942061185,36.6930493 1.725,35.914 C5.371,32.268 9.018,28.621 12.725,25.039 C13.109,24.655 13.493,24.399 13.876,24.079 C14.5182833,23.5925137 15.3099904,23.3449947 16.115,23.379 L28.144,23.379 C29.1011436,23.4474229 29.994933,23.882675 30.639,24.594 C32.686,26.577 34.733,28.56 36.78,30.479 C37.548,31.247 38.315,31.95 39.08,32.718 C39.4,33.038 39.528,33.038 39.848,32.718 C41.959,30.543 44.134,28.432 46.248,26.257 C46.632,25.873 46.824,25.873 47.208,26.257 C48.743,27.857 50.343,29.457 51.942,31.057 C52.198,31.313 52.262,31.441 51.942,31.757 C48.935,34.892 45.929,38.026 42.922,41.097 C42.3714924,41.6746749 41.691925,42.1136693 40.939,42.378 C39.5730153,42.9565523 37.9913131,42.6247378 36.973,41.546 C35.246,39.883 33.582,38.155 31.855,36.492 C31.727,36.364 31.535,36.236 31.343,36.044 Z M12.535,36.172 C12.407,36.236 12.407,36.236 12.343,36.236 C11.895,36.748 11.383,37.196 10.936,37.707 C10.616,38.091 9.976,38.407 10.036,38.858 C10.1,39.242 10.676,39.626 10.996,39.946 L12.467,41.417 C12.535,39.627 12.535,37.9 12.535,36.172 Z"
                          id="Path_333"
                        />
                        <path
                          d="M22.131,20.499 C17.7497251,20.499 14.198,16.9472749 14.198,12.566 C14.198,8.18472508 17.7497251,4.633 22.131,4.633 C26.5122749,4.633 30.064,8.18472508 30.064,12.566 C30.0426615,16.9384057 26.5034057,20.4776615 22.131,20.499 Z"
                          id="Path_334"
                        />
                        <path
                          d="M54.5,20.627 C54.7398987,20.617789 54.9788847,20.6614893 55.2,20.755 C55.712,21.011 55.9,20.819 56.1,20.371 L65.887,2.139 C66.1362659,1.67786825 66.6474869,1.42205791 67.166,1.499 C67.6826517,1.43095537 68.1807224,1.7179097 68.381,2.199 C68.6483317,2.7494599 68.6243409,3.39683659 68.317,3.926 C64.992,9.943 61.724,15.957 58.466,21.906 C58.1811455,22.3414418 58.1104554,22.8830316 58.274,23.377 C58.6868608,24.5774992 58.3029498,25.9079908 57.314,26.704 C56.614,27.344 55.907,27.919 55.267,28.623 C55.011,28.879 54.883,28.815 54.627,28.623 L50.024,24.209 C49.896,24.081 49.768,23.953 49.896,23.697 C50.6617327,22.3853107 51.8282901,21.3540571 53.224,20.755 C53.64417,20.6710146 54.0715201,20.6281456 54.5,20.627 Z"
                          id="Path_335"
                        />
                        <polyline points="71.709 8.088 79.322 8.088 79.322 59.074 42.474 59.074 42.474 46.215" />
                        <polyline points="42.474 24.465 42.474 8.088 57.507 8.088" />
                      </g>
                    </g>
                  </svg>
                </div>
                <h5>Training</h5>
              </div>
              <div className="content-block">
                <h2>Training Course</h2>
                <p>
                  At Separations, we are constantly aiming at broadening skills and 
                  therefore we offer multiple training courses during the year.  
                  Improve your product knowledge/performance and learn industry 
                  best practice with our world class training and workshops.
                  Gain the skills needed for a full range of product related activities.
                </p>
              </div>
              <div className="control">
                <a
                  onClick={() => {
                    this.setState({ requestModalOpen: true, heading: 'Training Request' });
                  }}
                  className="button button-green"
                >
                  Request Training
                </a>
              </div>
            </li>
          </ul>
        </div>
</div>


            );
          }
          if (error) {
            console.log(error);
            return <div>Error</div>;
          }
          var html = data.getContent.body;
          var buttons = html.match(/<a[\s\S]*?>([\s\S]*?)<\/a>/g);

          return (

            <div>
          {buttons.map((b,i)=>{
              var m = b.match(/<a[\s\S]*?>([\s\S]*?)<\/a>/);
              var txt = m[1];
              return (
                        <a 
                          onClick={() => {
                            this.setState({ requestModalOpen: true, heading: txt });
                          }}
                          className="button button-green"
                          style={{display:"none"}}
                          id={txt}
                          key={i}

                        >
                          {txt}
                        </a>
                          )
          })}
                    <div dangerouslySetInnerHTML={{__html: html}}
                      onClick={(ev,ui) => {
                        console.log("clickety click");
  console.log("clicked");
    var cls = ev.target.className;
    var tag = ev.target.tagName;
    var targetid = ev.target.innerHTML;
    if(tag=="A" && cls=="button button-green"){
        document.querySelector("[id='" + targetid + "']").click();
    }                     
                      }}
                   />            
         
            </div>
          );

        }}
      </Query>

        <Footer />
      </div>
    );
  }
}

export default LaboratoryServices;



// WEBPACK FOOTER //
// ./src/pages/laboratoryServices/laboratoryServices.page.js